import { ChangeDetectionStrategy, Component, ElementRef } from "@angular/core";

@Component({
    selector: 'cs-item-list',
    templateUrl: 'cs-item-list.html',
    host: { 'class': 'item-list' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsItemListComponent {

  constructor(public elementRef: ElementRef) {
  }
}